import { makeObservable, observable } from 'mobx';
import Bookkeeping from '../../model/Bookkeeping';
import CompanyStore from '../CompanyStore';

class FortnoxBookkeepingStore {
  companyStore: CompanyStore;

  history: Bookkeeping[] = [];

  loading = false;

  historyError: string | null = null;

  bookkeeper: string | undefined;

  constructor(companyStore: CompanyStore) {
    this.companyStore = companyStore;
    makeObservable(this, {
      history: observable,
      loading: observable,
      bookkeeper: observable,
    });
  }
}

export default FortnoxBookkeepingStore;
